import { Autocomplete, Grid, TextField } from "@mui/material";
import Disabled from "components/common/Disabled";
import * as labels from "config.labels";
import * as staticDataService from "services/staticDataService";
import * as staticDataHooks from "store/hooks/staticDataHooks";

const FormOfBusiness = ({ formOfBusiness, updateProgram }) => {
  const translateLabel = staticDataHooks.useTranslator("uiLabels");
  const { data: autoCompletions, isLoading } = staticDataService.useConfigQuery(
    "auto_completions"
  );

  const formsOfBusiness = autoCompletions?.input_program_formOfBusiness ?? [];

  return (
    <Grid item xs={6}>
      <Disabled ifReadOnly>
        <Autocomplete
          value={
            formsOfBusiness.find(({ key }) => key === formOfBusiness) ?? null
          }
          onChange={(_, value) =>
            updateProgram({
              formOfBusiness: value?.key ?? null,
            })
          }
          options={formsOfBusiness}
          getOptionLabel={(option) => option?.name ?? ""}
          isOptionEqualToValue={(option, value) => option?.key === value?.key}
          renderInput={(params) => (
            <TextField
              {...params}
              variant={"filled"}
              label={translateLabel(labels.PROGRAM_FORM_OF_BUSINESS_LABEL, {
                default: "Form of Business",
              })}
              InputLabelProps={{ shrink: true }}
            />
          )}
          autoHighlight
          sx={{ width: "100%" }}
          disabled={isLoading}
          id={"program-inputs-form-of-business"}
        />
      </Disabled>
    </Grid>
  );
};

export default FormOfBusiness;
